export enum ProcessStepType {
  ACCEPT = 'accept',
  DECLINE = 'decline',
  INBOX = 'inbox',
  PRE_QUALIFICATION = 'pre-qualification',
  INDIVIDUAL = 'individual',
}

